import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-info',
  imports: [],
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss'
})
export class InfoComponent {
  message = input.required<string>();
  close = input<boolean>();
  onClose = output<void>();

  closeToast() {
    this.onClose.emit();
  }
}

